export const uploadFileToGCS = async (file, onProgress) => {
    // Add file size check
    const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
    if (file.size > MAX_FILE_SIZE) {
        throw new Error(`File size exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB limit`);
    }

    const formData = new FormData();
    formData.append('file', file);

    try {
        const runtimeApiUrl = (typeof window !== 'undefined' && window._env_ && window._env_.REACT_APP_API_URL)
          ? window._env_.REACT_APP_API_URL
          : process.env.REACT_APP_API_URL;
        const response = await fetch(`${runtimeApiUrl}/api/upload`, {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
          },
          credentials: 'include',
          body: formData,
          signal: AbortSignal.timeout(120000), // 2 minute timeout for larger files
      });

        const data = await response.json();

        if (!response.ok) {
            console.error('Server response:', data);
            throw new Error(`Error uploading file: ${data.error}. Details: ${data.details}`);
        }

        console.log('File uploaded successfully:', data);
        return { publicUrl: data.publicUrl };
    } catch (error) {
        console.error('Error in uploadFileToGCS:', error);
        throw error;
    }
};